export function useRedirect(url = "/") {
  const navigationStore = useNavigationStore();

  if (navigationStore.redirect) {
    const redirect = unref(navigationStore.redirect);
    navigationStore.redirect = null;

    return navigateTo(redirect.url, { replace: true });
  }
  return navigateTo(url, { replace: true });
}

export function useLogout() {
  const localStorage = useLocalStorage();
  localStorage.remove("access");

  return navigateTo(import.meta.env.VITE_LIVE_URL, { external: true });
}
